import { Sidebar } from "features/layout/components";
import { LeadPreviewContent } from "features/leads/components/index";

import type { Lead } from "common/types";

interface LeadPreviewProps {
  initialState: string | Lead;
  isOpen: boolean;
  onClose: () => void;
  mode?: "inbox" | "leadDetails";
}

export default function LeadPreviewSidebar({
  initialState,
  isOpen,
  onClose,
  mode,
}: LeadPreviewProps) {
  const leadPreviewContentProps =
    typeof initialState === "string"
      ? { initialState }
      : { initialState, onClose };

  return (
    <Sidebar isOpen={isOpen} onClose={onClose}>
      <LeadPreviewContent {...leadPreviewContentProps} mode={mode} />
    </Sidebar>
  );
}
